import type { Translation } from '../types.ts';
import type en from '../en/ui.ts';

export default {
    errors: {
        network: 'De server is niet bereikbaar. Controleer je verbinding en probeer het opnieuw.',
        validation: 'Validatie mislukt',
    },
    toast: {
        dismiss: 'Melding sluiten',
    },
    localeTabs: {
        edit: '{locale} bewerken',
        default: 'standaard',
    },
    richText: {
        bold: 'Vet (Ctrl+B)',
        italic: 'Cursief (Ctrl+I, em)',
        underline: 'Onderstrepen (Ctrl+U)',
        strike: 'Doorhalen',
        paragraph: 'Alinea',
        heading2: 'Kop 2',
        heading3: 'Kop 3',
        bulletList: 'Opsomming',
        orderedList: 'Genummerde lijst',
        blockquote: 'Citaat',
        link: 'Link',
        linkPrompt: 'Link-URL',
        insertImage: 'Afbeelding invoegen',
        uploadFailed: 'Uploaden van de afbeelding is mislukt.',
    },
    access: {
        label: 'Wie mag dit zien',
        thing: {
            page: 'deze pagina',
            article: 'dit artikel',
            product: 'dit product',
            menuEntry: 'dit menu-item',
        },
        needsCustomers: 'Om {thing} af te schermen zijn klantaccounts nodig. Zet eerst de module {module} aan op het tabblad Modules van de website.',
        customersModule: 'Klanten',
        loadingGroups: 'Groepen laden…',
        loadFailed: 'De klantgroepen konden niet worden geladen.',
        noGroups: 'Nog geen klantgroepen. Maak er een aan onder {path}.',
        groupsPath: 'Klanten → Klantgroepen',
        memberCount: '{n} leden | {n} lid | {n} leden',
        pickGroup: 'Kies minstens één groep. Zonder geselecteerde groep is {thing} voor niemand zichtbaar.',
        restrictedNote: 'Afgeschermde inhoud blijft buiten menu\'s, overzichten en de sitemap, en wordt nooit gecachet voor andere bezoekers. Bezoekers die niet zijn ingelogd, gaan naar de inlogpagina.',
    },
    storage: {
        title: 'Opslag',
        ofQuota: 'van {quota}',
        noQuota: 'geen limiet',
        critical: 'Bijna vol. Zodra de limiet is bereikt, worden nieuwe uploads en back-ups geweigerd.',
        warn: 'Raakt vol. Verwijder ongebruikte media of verhoog de limiet.',
        notCounted: '(telt niet mee)',
        onDisk: 'In totaal {size} op schijf.',
        measured: 'Media, videoversies en back-ups zijn actueel; de rest is voor het laatst gemeten op {date}.',
        notMeasured: "Thema's, bijlagen en cache zijn nog niet gemeten: dat gebeurt elke nacht.",
        quotaLabel: 'Opslaglimiet (GB)',
        quotaHint: "Laat leeg voor geen limiet. Telt media, videoversies, back-ups, reviewfoto's, formulierbijlagen en themaversies mee, maar niet de afbeeldingscache (die opnieuw kan worden opgebouwd).",
        quotaReadOnly: 'De limiet is {quota}. Alleen een superbeheerder kan die wijzigen.',
    },
    upload: {
        sending: 'Versturen',
        processing: 'Verwerken',
        finishing: 'Afronden',
        transcodingHint: "Omzetten naar een formaat dat elke browser kan afspelen. Grote video's duren een paar minuten.",
        renditionsHint: 'Kleinere versies maken voor telefoons en trage verbindingen.',
    },
    rejectedFields: {
        title: 'Opgeslagen, maar {n} veld is niet bewaard. | Opgeslagen, maar {n} velden zijn niet bewaard.',
        partly: '(deels opgeslagen)',
        dismiss: 'Sluiten',
    },
} satisfies Translation<typeof en>;
